import React from "react";
import { useSelector } from "react-redux";
import { Box, Button, CircularProgress, TextField } from "@mui/material";
import { Formik } from "formik";
import Header from "../../components/Header";
import * as yup from "yup";

function SendOtp({ onSubmit }) {

  const { isLoading } = useSelector(({ loading }) => ({
    isLoading: loading,
  }));
  const initialValues = {
    email: "",
  };
  const checkoutSchema = yup.object().shape({
    email: yup.string().email("Invalid email!").required("Required"),
  });
  return (
    <>
      <Box m="20px">
        <Header title="HOTEL LOGIN" subtitle="Enter your email" />
        <Formik
          onSubmit={onSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                required
                variant="filled"
                type="text"
                label="Email"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.email}
                name="email"
                error={!!touched.email && !!errors.email}
                helperText={touched.email && errors.email}
                // sx={{ gridColumn: "span 4" }}
              />
              <Box mt="20px">
                <Button
                  fullWidth
                  size="large"
                  type="submit"
                  color="secondary"
                  variant="contained"
                  sx={{ fontSize: "15px" }}
                >
                  {isLoading ? <CircularProgress color="inherit" size={24} /> : <b>SEND OTP</b>}
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    </>
  );
}

export default SendOtp;
